import { render, staticRenderFns } from "./Screen_2.vue?vue&type=template&id=4b9e4d6a&"
import script from "./Screen_2.vue?vue&type=script&lang=ts&"
export * from "./Screen_2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports